import { z } from 'zod';
import type { AISchemaField, UISchemaField } from '../types/index';

/**
 * 位置情報セクション。
 * - address から Google Maps 埋め込み URL を自動生成（API キー不要）
 * - 上級者向けに mapEmbedUrl で iframe URL を直接指定可能
 */
export const locationAISchema: AISchemaField[] = [
  { name: 'eyebrow', type: 'string', required: false, max: 30 },
  { name: 'headline', type: 'string', required: false, max: 80 },
  { name: 'address', type: 'string', required: true, max: 200, hint: '会場の住所（地図検索に使われる）' },
  {
    name: 'notes',
    type: 'string',
    required: false,
    max: 300,
    hint: '最寄駅からの所要時間、駐車場情報、入口案内などの補足',
  },
  {
    name: 'mapEmbedUrl',
    type: 'url',
    required: false,
    hint: 'Google Maps の埋め込み iframe コード or src URL（指定なしなら address から自動生成）',
  },
  { name: 'addressLabel', type: 'string', required: false, max: 20, hint: '住所ブロックのラベル (省略時は「住所」)' },
  { name: 'accessLabel', type: 'string', required: false, max: 20, hint: '補足情報ブロックのラベル (省略時は「アクセス」)' },
];

export const locationUISchema: UISchemaField[] = [
  { name: 'eyebrow', type: 'text', label: 'Eyebrow', max: 30 },
  { name: 'headline', type: 'text', label: '見出し', max: 80 },
  { name: 'address', type: 'textarea', label: '住所', required: true, max: 200 },
  { name: 'notes', type: 'textarea', label: '補足情報（最寄駅・駐車場など）', max: 300 },
  {
    name: 'mapEmbedUrl',
    type: 'textarea',
    label: 'Google Maps 埋め込みコード or URL（任意）',
    placeholder: '空欄で住所から自動生成 / Google Maps「共有 → 地図を埋め込む」の <iframe> コードをそのまま貼り付け可',
  },
  { name: 'addressLabel', type: 'text', label: '住所ブロックのラベル (省略時は「住所」)', max: 20 },
  { name: 'accessLabel', type: 'text', label: '補足ブロックのラベル (省略時は「アクセス」)', max: 20 },
];

export const locationZodSchema = z.object({
  eyebrow: z.string().max(30).optional().nullable(),
  headline: z.string().max(80).optional().nullable(),
  address: z.string().min(1).max(200),
  notes: z.string().max(300).optional().nullable(),
  mapEmbedUrl: z.string().optional().nullable(),
  addressLabel: z.string().max(20).optional().nullable(),
  accessLabel: z.string().max(20).optional().nullable(),
});

export type LocationContent = z.infer<typeof locationZodSchema>;

export const locationSample: LocationContent = {
  eyebrow: '会場',
  headline: 'カウデザイン 南青山オフィス',
  address: '東京都港区南青山4-21-26 5階',
  notes: '東京メトロ 表参道駅 A4出口から徒歩7分 / 専用駐車場あり（要事前連絡）',
  mapEmbedUrl: null,
  addressLabel: null,
  accessLabel: null,
};
